export default "__VITE_ASSET__CO0Xnwwo__"